import * as sh from "../plugin/simulator.js";
//import * as sh from "../plugin/simulator.test.js";

const elements = {
    disclaimer: document.querySelector("#disclaimer"),
    sliderAmount: document.getElementById("range-slider-amount"),
    sliderRate: document.getElementById("range-slider-rate"),
    sliderAmountFiller: document.getElementById("range-fill-amount"),
    sliderRateFiller: document.getElementById("range-fill-rate"),
    tan: document.querySelectorAll("[data-id='tan']"),
    taeg: document.querySelectorAll("[data-id='taeg']"),
    stikyrata: document.querySelectorAll("[data-id='imp-rata']"),
    stikyimporto: document.querySelectorAll("[data-id='importo']"),
    minrata: document.querySelector(`div[data-id="n-min-rate"]`),
    maxrata: document.querySelector(`div[data-id="n-max-rate"]`),
    valuerata: document.getElementById("value-rate"),
    valueimporto: document.getElementById("value-amount"),
    cta: document.getElementById("btn-goto-form"),
    //sticky: document.querySelector(".fly-offer .width-cnt p"),
    stickyhref: document.querySelector(".fly-offer .width-cnt a"),
    minImport: document.getElementById(`min-rata`),
    maxImport: document.getElementById(`max-rata`),
}

var simulatorHelper = sh.SimulatorHelper(elements, window.configurationData);

var updateUrl = simulatorHelper.updateUrl;